import React from 'react';
import { FormattedMessage } from 'react-intl';


const CHEQUING_TRANSACTIONS = [
    0,
    1,
    5,
    15,
    30,
    50,
];

const CHEQUING_TRANSACTIONS_OPTIONS = Object.values(CHEQUING_TRANSACTIONS).map(value => ({
    value: value,
    label: (
        <FormattedMessage
            id="edb.chequing.transactions-option"
            defaultMessage="{transactionsCount}/month"
            values={{ transactionsCount: value }}
        />
    ),
}));


export { CHEQUING_TRANSACTIONS };
export default CHEQUING_TRANSACTIONS_OPTIONS;
